module.exports = __webpack_public_path__ + "img/edit_section.bbfe04e5.svg";